<template>
  <div class="file-system-container modal-overflow">
    <breadcrumbs v-if="folderPath" :path="folderPath" @click="breadcrumbs"></breadcrumbs>
    <hr />
    <div v-for="folder in fileSystem.folders" style="margin-top: 15px;">
      <div>
        <span class="folder-icon"><a href="#" @click.prevent="fetchDirectoryContents(folder)"><img src="static/img/file-mgr/folder.png" /></a></span>
        <a href="#" @click.prevent="fetchDirectoryContents(folder)">{{folder}}</a>
      </div>
    </div>
    <div class="one-file" v-for="file in fileSystem.files">
      <span class="file-icon"><a href="#" @click.prevent="downloadFileOrFlatPdf(file)"><img :src="'static/img/file-mgr/' + icon(file)" /></a></span>
      <a href="#" @click.prevent="downloadFileOrFlatPdf(file)">{{file}}</a>
      <button :ref="`openFile${file}`" class="dlPdfButton" @click.prevent="downloadFile(file, true)" style="padding-left: 7px; margin-right: -4px; visibility: hidden" title="Open File"><img src="static/img/file-mgr/open.png" /></button>
      <button :ref="`downloadPdf${file}`" class="dlPdfButton" @click.prevent="downloadFile(file)" style="visibility: hidden" title="Download Editable PDF"><img src="static/img/file-mgr/dl-editable-pdf.png" /></button>
    </div>
    <div v-if="fileSystem.folders.length === 0 && fileSystem.files.length === 0">
      No files or folders found.
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {formatFileSize, icon} from 'src/utilities/utils'
  import Breadcrumbs from 'src/components/Dashboard/Views/Files/Modal/Breadcrumbs.vue'
  import Permissions from 'src/utilities/permissions'

  export default{
    props: ['data'],
    components: {
      Breadcrumbs
    },
    computed: {
      ...mapGetters({
        fileName: 'files/fileName',
        fileSystem: 'files/fileSystem',
      }),
      fileSize() {
        return formatFileSize(this.totalSizeInBytes)
      }
    },
    data() {
      return {
        folderPath: null
      }
    },
    methods: {
      breadcrumbs(path) {
        this.$store.commit('files/jobId', null)
        this.$store.commit('files/jobPath', null)
        this.folderPath = path
      },
      downloadFileOrFlatPdf(fileName) {
        if (fileName.endsWith(".pdf")) {
          this.$store.dispatch('files/downloadFlatPdf', {
            name: fileName,
            path: this.folderPath
          })
          return
        }
        this.downloadFile(fileName, false)
      },
      downloadFile(fileName, openFile = false) {
        const payload = {
          name: fileName,
          path: this.folderPath,
          openFile,
          useDirectFileUploadAndDownload: true
        }

        this.$store.dispatch('files/download', payload)
      },
      icon(file) {
        return icon(file)
      },
      async fetchDirectoryContents(folder) {
        this.folderPath += '/' + folder
        await this.$store.dispatch('files/fetchDirectoryContents', this.folderPath)
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    mounted() {
      this.folderPath = this.data
      this.$store.dispatch('files/fetchDirectoryContents', this.folderPath)
    },
    destroyed() {
      this.$store.commit('files/fileName', null)
      this.$store.commit('files/jobId', null)
      this.$store.commit('files/jobPath', null)
      this.$store.commit('files/resetFileSystem', null)
    }
  }
</script>

<style scoped>
  .file-icon, .folder-icon {
    padding-right: 5px;
  }
  .one-file {
    padding-bottom: 5px;
  }
  .dlPdfButton {
    border: none;
    background: transparent;
    cursor: pointer
  }
  .dlPdfButton:focus {
    outline: 0;
  }
</style>
